import api from './api';

export async function bulkDeleteDocuments(documentIds) {
  return api.delete('/documents/bulk', { data: { document_ids: documentIds } });
}

export const documentService = {
  async list(params = {}) {
    const response = await api.get('/documents/', { params });
    return response.data;
  },

  async create(payload) {
    const response = await api.post('/documents/', payload);
    return response.data;
  },

  async get(id) {
    const response = await api.get(`/documents/${id}`);
    return response.data;
  },

  async update(id, payload) {
    const response = await api.put(`/documents/${id}`, payload);
    return response.data;
  },

  async uploadFile(documentId, file) {
    const formData = new FormData();
    formData.append('file', file);
    // Let Axios/browser set the correct multipart boundary. Do not set Content-Type explicitly.
    const response = await api.post(`/documents/${documentId}/upload`, formData);
    return response.data;
  },

  async listFiles(documentId) {
    const response = await api.get(`/documents/${documentId}/files`);
    return response.data;
  },

  async downloadFile(fileId) {
    const response = await api.get(`/documents/files/${fileId}/download`, {
      responseType: 'blob',
    });
    return response.data;
  },

  getPreviewUrl(fileId) {
    if (typeof window !== 'undefined') {
      return `${window.location.origin}/api/v1/documents/files/${fileId}/preview`;
    }
    const baseUrl = (api.defaults.baseURL || '').replace(/\/$/, '');
    return `${baseUrl}/documents/files/${fileId}/preview`;
  },

  async validate(documentId, approve = true, notes = null) {
    const response = await api.post(`/documents/${documentId}/validate`, null, {
      params: { approve, notes },
    });
    return response.data;
  },

  async delete(documentId) {
    console.log('Service DELETE request for document:', documentId);
    const response = await api.delete(`/documents/${documentId}`);
    console.log('Delete response:', response);
    return response.data;
  },

  async getExpiring(days = 30) {
    const response = await api.get('/documents/expiring', { params: { days } });
    return response.data;
  },

  async updateNotification(documentId, notify_on_expiration) {
    const response = await api.patch(`/documents/${documentId}/notification`, {
      notify_on_expiration,
    });
    return response.data;
  },

  async sendExpirationTest(documentId, toEmail = null) {
    const response = await api.post('/email/send-expiration-test', {
      document_id: documentId,
      to_email: toEmail || undefined,
    });
    return response.data;
  },
};
